import axios from 'axios'
import { BFF_HOME_API_ENDPOINT_V2, BFF_HOME_API_ENDPOINT_V3 } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { keysToSnakecase, transformResponse } from '~/domains/platform/infra/http/http-helpers'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientBffHomeV2 = httpClientFactory({
  baseURL: BFF_HOME_API_ENDPOINT_V2(),
  transformRequest: [keysToSnakecase, ...(axios.defaults.transformRequest as any[])],
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})

export const httpClientBffHomeV3 = httpClientFactory({
  baseURL: BFF_HOME_API_ENDPOINT_V3(),
  transformRequest: [keysToSnakecase, ...(axios.defaults.transformRequest as any[])],
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
